export default "__VITE_ASSET__MSBpFRJ0__"